export default __webpack_public_path__ + "static/media/mobile-maq.f938798f.png";